<template>
    <div class="box-shadow-inside box-background box-ssjc mt20">
        <el-carousel height="390px">
            <el-carousel-item >
                <monitor-echarts-three></monitor-echarts-three>
            </el-carousel-item>
            <el-carousel-item >
                <monitor-echarts-four></monitor-echarts-four>
            </el-carousel-item>
            <el-carousel-item >
                <monitor-echarts-five></monitor-echarts-five>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
import MonitorEchartsThree from './MonitorEchartsThree'
import MonitorEchartsFour from './MonitorEchartsFour'
import MonitorEchartsFive from './MonitorEchartsFive'

export default {
    name: 'MonitorRightCarousel',
    components: {
        MonitorEchartsThree,
        MonitorEchartsFour,
        MonitorEchartsFive
    },
    data() {
        return {}
    },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorRightCarousel.vue